export default __webpack_public_path__ + "static/media/Xcode.94d5c88d.png";